import styled from 'styled-components'

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`

export const StepWrapper = styled.div`
max-width: 400px;
margin: 0 auto;
`